import { QueryKey } from '@tanstack/react-query';

import { AccountId, PlaidCreateTokenLinkRequest } from '@arrived/models';

export const accountsKeyRoot = 'accounts';

export const accountsKeyFn = (accountId: AccountId): QueryKey => [accountsKeyRoot, accountId];

export const accountsTaxIdKeyFn = (accountId: AccountId): QueryKey =>
  (accountsKeyFn(accountId) as readonly unknown[]).concat(['taxId']);

export const beneficiariesKeyFn = (accountId: AccountId): QueryKey =>
  (accountsKeyFn(accountId) as readonly unknown[]).concat(['beneficiaries']);

// TODO: Change back to 'balance' after old endpoint is deprecated
export const balanceKeyFn = (accountId: AccountId): QueryKey =>
  (accountsKeyFn(accountId) as readonly unknown[]).concat(['balanceV2']);

export const offeringBalancesKeyFn = (accountId: AccountId): QueryKey =>
  (accountsKeyFn(accountId) as readonly unknown[]).concat(['balanceV2', 'offerings']);

export const plaidTokenLinkKeyFn = ({ userId, ...rest }: PlaidCreateTokenLinkRequest): QueryKey => [
  'users',
  userId,
  'plaid',
  'token',
  rest,
];

export const plaidVerificationTokenLinkKeyFn = (accountId: AccountId): QueryKey => [
  'accounts',
  accountId,
  'plaid',
  'token',
  'verify',
];
